module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "mcontent"
  }, [_c('div', {
    staticClass: "desc"
  }, [_c('h4', [_vm._v("我们为什么要创建前沿社：")]), _c('a', {
    attrs: {
      "href": "http://mp.weixin.qq.com/s?__biz=MzI5ODY0NTAxNA==&sn=9a2ae8993e1c62d5ee9b89a03e8ca2ce&mid=2247483706&idx=1",
      "target": "_blank"
    }
  }, [_vm._v("那群快速自我迭代的成功者身上到底有哪些共性的“赢家特质”？")])]), _c('img', {
    staticClass: "go",
    attrs: {
      "src": require("../../assets/imgs/go-m.jpg"),
      "alt": "我们曾抵达..."
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-29c75fa8!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/mobile/Content.vue
// module id = 194
// module chunks = 1